import { updatePlayer } from "../api/requests/player.requests.js";
import { StatisticsStorage } from "../storage/statistics_storage.js";
import type { GameEventID } from "../events_config/events_config_service.js";

export enum FeatureTutorialID
{
  DailyChallenge = 1,
  DailyTasks = 2,
  ChainOffer = 3,
  WinStreakTower = 4,
}

export const FEATURE_TUTORIAL_BY_EVENT: Partial<Record<GameEventID, FeatureTutorialID>> = {
  daily_challenge: FeatureTutorialID.DailyChallenge,
  daily_tasks: FeatureTutorialID.DailyTasks,
  chain_offer: FeatureTutorialID.ChainOffer,
  win_streak_tower: FeatureTutorialID.WinStreakTower,
};

export class FeatureTutorialService
{
  private static completed_cache: FeatureTutorialID[] = [];
  private static completed_cache_version = -1;

  public static isCompleted( id: FeatureTutorialID ): boolean
  {
    const version = StatisticsStorage.getVersion();
    if ( version !== this.completed_cache_version )
    {
      this.completed_cache = StatisticsStorage.load().completed_feature_tutorials;
      this.completed_cache_version = StatisticsStorage.getVersion();
    }
    return this.completed_cache.includes( id );
  }

  public static reset(): void
  {
    StatisticsStorage.update( { completed_feature_tutorials: [] } );
    void updatePlayer( { completed_feature_tutorials: [] } )
      .catch( e => console.warn( '[FeatureTutorial] server sync failed', e ) );
  }

  public static complete( id: FeatureTutorialID ): void
  {
    const stats = StatisticsStorage.load();
    if ( stats.completed_feature_tutorials.includes( id ) )
      return;

    const completed = [ ...stats.completed_feature_tutorials, id ];
    StatisticsStorage.update( { completed_feature_tutorials: completed } );
    void updatePlayer( { completed_feature_tutorials: completed } )
      .catch( e => console.warn( '[FeatureTutorial] server sync failed', e ) );
  }
}
